import styled from 'styled-components';
import { Loader } from '../../../components/Loader';

export const Loading = styled(Loader)`
  padding: 20px;
`;
